import { useNavigate } from 'react-router-dom';

import BackLink from '../components/BackLink';
import Footer from '../components/Footer';
import Scoreboard from '../components/Scoreboard';
import { CHOICES } from '../game';

// The board is laid out as two rows: three choices, then two.
const ROWS = [CHOICES.slice(0, 3), CHOICES.slice(3)];

function Play({ score, onPlay }) {
  const navigate = useNavigate();

  const handlePlay = (choiceName) => {
    onPlay(choiceName);
    navigate('/Res');
  };

  return (
    <section className="gameSec">
      <div className="gameContainer">
        <div className="gameTop">
          <BackLink />
        </div>

        <Scoreboard score={score} />

        <div className="gameBtns">
          {ROWS.map((row, index) => (
            <div className="rowBtns" key={index}>
              {row.map((choice) => (
                <div key={choice.name}>
                  <button
                    type="button"
                    onClick={() => handlePlay(choice.name)}
                    aria-label={`Play ${choice.name}`}
                  >
                    <img src={choice.img} alt="" />
                  </button>
                  {choice.name}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default Play;
